import React, { createContext, useContext } from 'react';
import { Todo, TodoCreateData, TodoList, Workspace } from '../../types/types';
import { useTodoManager } from './useTodoManager';

export interface TodoContextType {
    reorderList: (sourceIndex: number, destinationIndex: number) => Promise<boolean>;
    moveTodoToList: (todoId: string, sourceListId: string, destinationListId: string, destinationIndex: number) => Promise<boolean>;
    updateListTitle: (listId: string, title: string) => Promise<boolean>;
    updateWorkspace: (workspaceId: string, updates: Partial<Workspace>) => Promise<Workspace>;

    //Todo
    todos: Todo[];
    todosMap: Map<string, Todo>;
    addTodo: (text: string, listId?: string) => Promise<Todo>;
    editTodo: (id: string, updatedTodo: Partial<Todo>) => Promise<Todo | null>;
    deleteTodo: (id: string) => void;
    toggleTodo: (id: string) => void;
    addTodoByTodoData: (todoData: TodoCreateData, listId?: string) => Promise<Todo | null>;

    //Workspace
    workspacesServer: Workspace[];
    workspacesLocal: Workspace[];
    addWorkspace: (isLocal: boolean) => Promise<Workspace>;
    deleteWorkspace: (workspaceId: string) => Promise<boolean>;
    activeWorkspace: string | null | undefined;
    currentWorkspace: Workspace | null | undefined;
    setActiveWorkspace: (workspaceId: string) => void;

    //List
    lists: TodoList[];
    workspacesList: TodoList[];
    addList: (title?: string, todos?: string[]) => Promise<TodoList>;
    deleteList: (listId: string) => Promise<boolean>;
}

export const TodoContext = createContext<TodoContextType | undefined>(undefined);

export const TodoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const todoManager = useTodoManager();
    return <TodoContext.Provider value={todoManager}>{children}</TodoContext.Provider>;
};

export const useTodos = () => {
    const context = useContext(TodoContext);
    if (context === undefined) {
        throw new Error('useTodos must be used within a TodoProvider');
    }
    return context;
}; 